export type User = {
  id: number;
  name: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  kind: string;
  status: string;
  phone: string | null;
  employer: {
    id: string | null;
    name: string | null;
  };
  employedAt: string | null;
  avatar: string | null;
  supportChatId?: string;
  links: string[];
  verified: boolean;
  isAmbassador: boolean;
  activeListings: string;
  draftListings: string;
  archivedListings: string;
  notifications: string;
  clientRequests: string;
  lastSeen: string;
};

export type BlockHistory = {
  reason: string;
  adminId: number;
  adminName: string;
  kind: string;
  createdAt: string;
};

export type AdminUserRespose = {
  items: User[];
  total: number;
};

export type PartiallyRegisteredUser = Pick<
  User,
  'name' | 'kind' | 'phone' | 'email' | 'createdAt' | 'employer' | 'links'
> & { id: string };

export type UnregisteredUsersResponse = {
  items: PartiallyRegisteredUser[];
  total: number;
};

export type AdminUserExport = {
  name: string;
  email: string | null;
  phone: string | null;
};

export enum AmbassadorFilterValue {
  All = 'all',
  Ambassadors = 'ambassadors',
  NonAmbassadors = 'nonAmbassadors',
}
